var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [(!_vm.isData) ? _c('h6', [_vm._v(" No Data Found ")]) : _vm._e(), _vm._v(" "), (_vm.isData) ? _c('h6', {
    staticClass: "card-title",
    staticStyle: {
      "margin-left": "54px"
    }
  }, [_c('b', [_vm._v("Central Master Support")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.projects), function(project_obj, index) {
    return _c('div', {
      staticClass: "col-xs-4"
    }, [(project_obj.URLs.length > 0) ? _c('div', {
      staticClass: "card border-info",
      staticStyle: {
        "width": "20rem",
        "margin-left": "70px",
        "margin-right": "10px"
      }
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('h6', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(project_obj.projectname))]), _vm._v(" "), _c('ul', {
      staticClass: "nested"
    }, _vm._l((project_obj.URLs), function(role_obj, index) {
      return _c('li', {
        attrs: {
          "id": ""
        }
      }, [_c('span', {
        staticClass: "caret roles"
      }, [_vm._v("\n                        " + _vm._s(role_obj.permissionname) + "\n                        "), _c('a', {
        attrs: {
          "href": "#/festivalSupport"
        },
        on: {
          "click": function($event) {
            _vm.redirectToPage(project_obj.appurl, project_obj.projectid, role_obj.controllerurl)
          }
        }
      }, [_c('u', [_vm._v("Click Here "), _c('small', [_c('i', {
        staticClass: "fa fa-hand-pointer-o",
        attrs: {
          "aria-hidden": "true"
        }
      })])])])])])
    }))])]) : _vm._e()])
  })), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-148ce79b","hasScoped":true}!./src/views/components/festivalSupport/festivalSupport.component.html
// module id = 859
// module chunks = 1